import React, { Component } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'

import BkFlowRoomDetailsDefault from './layouts/BkFlowRoomDetailsDefault'
import BkFlowRoomDetailsSimplified from './layouts/BkFlowRoomDetailsSimplified'
import BkFlowRoomCardDescriptionAccordion from '../elements/BkFlowRoomCardDescriptionAccordion'

import _ from 'lodash'
import yn from 'yn'

class BkFlowRoomDetails extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	handleFullScreen = () => {
		const {
			roomData,
			roomGroup
		} = this.props

		const targetGallery = 'js-gallery-fullscreen__' + roomData.roomTypeCode + '-' + roomGroup
		document.getElementById(targetGallery).click()
	}

	render() {
		const {
			configData,
			hotelDescriptiveInfoData,
			roomData,
			roomDetailsExpanded,
			roomGroup,
			roomFloorPlanSrc,
			roomMapUrlSrc,
			virtualTourEvent,
			virtualTourSrc
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		// Initialize hotelDescriptiveInfo variables
		let unrefinedGuestRoom = null,
				unrefinedRoomDescription = null

		// Initialize and set hotelDescriptiveInfo data if matched
		if (
			yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
			hotelDescriptiveInfoData &&
			hotelDescriptiveInfoData.facilityInfo &&
			!_.isEmpty(hotelDescriptiveInfoData.facilityInfo.guestRooms)
		){
			unrefinedGuestRoom = hotelDescriptiveInfoData.facilityInfo.guestRooms.filter(function(room) {
				return room.Code === roomData.roomTypeCode
			})

			if (
				unrefinedGuestRoom &&
				unrefinedGuestRoom[0] &&
				unrefinedGuestRoom[0].multimediaDescriptions &&
				unrefinedGuestRoom[0].multimediaDescriptions.textItems
			) {
				unrefinedRoomDescription = unrefinedGuestRoom[0].multimediaDescriptions.textItems.filter(function(description) {
					return description.title === 'Short Description'
				})
			}
		}

		let combineIcons = false

		if (process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'condensed') {
			combineIcons = true
		}

		let renderRoomDescription = []
		const renderRoomLongDescription = _.get(roomData, 'viewExtensions.extendedRoomDescriptionText', null)

		if (
			yn(process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION_ROOM_DESCRIPTION) &&
			yn(process.env.REACT_APP_COMPONENT_BASE_CRS_DATA) &&
			!_.isEmpty(unrefinedGuestRoom) &&
			!_.isEmpty(unrefinedRoomDescription)
		) {
			renderRoomDescription.push(
				<BkFlowRoomCardDescriptionAccordion
					hotelLabels={hotelLabels}
					roomDescription={unrefinedRoomDescription[0]['en-US']}
					roomData={roomData}
				/>
			)
		} else if (
			roomData.roomDescription &&
			roomData.roomDescription.text
		){
			renderRoomDescription.push(
				<BkFlowRoomCardDescriptionAccordion
					key={'room-details-accordion-' + roomData.roomTypeCode + '-' + roomGroup}
					hotelLabels={ hotelLabels }
					roomDescription={ roomData.roomDescription.text }
					roomData={ roomData }
				/>
			)
		}

		return (
			<div className="bk-flow-room__details">
				<Collapse
					in={ roomDetailsExpanded }
					timeout={ 300 }
				>
					{ process.env.REACT_APP_COMPONENT_ROOM_DETAILS_ACCORDION_LAYOUT === 'simplified' ?
						<BkFlowRoomDetailsSimplified
							renderRoomDescription={renderRoomDescription}
							renderRoomLongDescription={renderRoomLongDescription}
						/>
					:
						<BkFlowRoomDetailsDefault
							combineIcons={combineIcons}
							fullScreenEvent={() => this.handleFullScreen()}
							hotelLabels={hotelLabels}
							renderRoomDescription={renderRoomDescription}
							renderRoomLongDescription={renderRoomLongDescription}
							roomData={roomData}
							roomFloorPlanSrc={roomFloorPlanSrc}
							roomGroup={roomGroup}
							roomMapUrlSrc={roomMapUrlSrc}
							virtualTourEvent={virtualTourEvent}
							virtualTourSrc={virtualTourSrc}
						/>
					}
				</Collapse>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		hotelDescriptiveInfoData: state.hotelDescriptiveInfo.hotelInfo
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomDetails)


// WEBPACK FOOTER //
// ./src/components/room/room-details/BkFlowRoomDetails.js